import {
  FETCH_BV_REVIEW_REQUEST,
  FETCH_BV_REVIEW_SUCCESS,
  FETCH_BV_REVIEW_FAILURE
} from '../../actionTypes/bazaarVoiceReviewActionTypes'

const fetchBVReviewRequest = payload => ({
  type: FETCH_BV_REVIEW_REQUEST,
  payload
})

const fetchBVReviewSuccess = payload => ({
  type: FETCH_BV_REVIEW_SUCCESS,
  payload
})

const fetchBVReviewFailure = payload => ({
  type: FETCH_BV_REVIEW_FAILURE,
  payload
})

export { fetchBVReviewRequest, fetchBVReviewSuccess, fetchBVReviewFailure }
